import { useState } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

// import Button from '@mui/material/Button';
// import PlayCircleFilledIcon from '@mui/icons-material/PlayCircleFilled';

import BtnShop from '../BtnShop/BtnShop';
import ItemsOfTheCourse from './ItemsOfTheCourse/ItemsOfTheCourse';
import ShowDiploma from './ShowDiploma/ShowDiploma';
import ShowTrailer from './ShowTrailer/ShowTrailer';
import UserProgressBar from './UserProgressBar/UserProgressBar';

import classes from './CourseSpecificInfo.module.css';

const url = window.location.pathname.split('/');

const CourseSpecificInfo = props => {
  const dataCourse = useSelector(state => state.courseInfo);
  const userInfo = useSelector(state => state.userInfo);
  const [openTrailer, setOpenTrailer] = useState(false);
  const openPreviewVideoHandler = () => {
    setOpenTrailer(!openTrailer);
  };

  return (
    <aside
      className={
        dataCourse.accessCourse
          ? url[2] !== 'course'
            ? classes.specificInfoAccessContainer
            : classes.specificInfoAccessContainerUrl
          : classes.specificInfoContainer
      }
    >
      {/* {props.dataCourse.trailerCourse.httpStatus === 200 && (
        <Button
          onClick={openPreviewVideoHandler}
          className={classes.specificTrailerBtn}
        >
          <PlayCircleFilledIcon
            className={classes.playTrailerIcon}
            style={{ top: 0 }}
          />
          <p className={classes.trailerText}>
            Ver trailer de este curso
          </p>
        </Button>
      )} */}
      <figure
        className={
          dataCourse.accessCourse
            ? classes.specificInfoAccessImage
            : classes.specificInfoImage
        }
      >
        <img
          className={classes.img}
          src={props.dataCourse.data.imgPathBig}
          alt=""
        />
      </figure>
      {dataCourse.accessCourse && (
        <UserProgressBar
          userAditionalTrack={props.dataCourse.userAditionalTrack}
          lessons={props.dataCourse.lessonsCourse}
        />
      )}
      <BtnShop />
      {!dataCourse.accessCourse && (
        <ItemsOfTheCourse dataCourse={props.dataCourse} />
      )}
      {dataCourse.missingActivities.length === 0 &&
        userInfo.data.usuario.length !== 0 && (
          <ShowDiploma
            dataCertificate={props.dataCourse.userDegree}
            titleCourse={dataCourse.data.nombre}
          />
        )}
      {props.dataCourse.trailerCourse.httpStatus === 200 && (
        <ShowTrailer
          openTrailer={openTrailer}
          onClose={openPreviewVideoHandler}
          trailerData={props.dataCourse.trailerCourse.response}
        />
      )}
    </aside>
  );
};

CourseSpecificInfo.propTypes = {
  // eslint-disable-next-line react/require-default-props
  dataCourse: PropTypes.object
};

export default CourseSpecificInfo;
